




































































import { Audit } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class HistoricalChangesList extends Vue {
  @Prop({ required: true, type: Array }) audits: Audit[]
  @Prop({ required: true, type: Boolean }) loading: boolean
  @Prop({ required: true, type: String }) accordionId: string
  @Prop({ required: false, type: Number, default: 10 }) perPage: number

  private currentPage = 1
  private changedFieldsMap: { [auditId: number]: string[] } = {}

  @Watch('audits', { immediate: true })
  onAuditsChanged() {
    this.currentPage = 1
    const map: { [auditId: number]: string[] } = {}
    for (const audit of this.audits) {
      map[audit.auditId] = this.computeChangedFields(audit)
    }
    this.changedFieldsMap = map
  }

  get paginatedAudits(): Audit[] {
    const start = (this.currentPage - 1) * this.perPage
    return this.audits.slice(start, start + this.perPage)
  }

  getChangedFields(audit: Audit): string[] {
    return this.changedFieldsMap[audit.auditId] || []
  }

  getChangedFieldsCount(audit: Audit): number {
    return this.getChangedFields(audit).length
  }

  private computeChangedFields(audit: Audit): string[] {
    const oldValue = (audit.oldValue || {}) as Record<string, unknown>
    const newValue = (audit.newValue || {}) as Record<string, unknown>
    const allKeys = Array.from(new Set([...Object.keys(oldValue), ...Object.keys(newValue)]))
    return allKeys.filter((key) => {
      const oldVal = oldValue[key]
      const newVal = newValue[key]
      if (typeof oldVal === 'object' && typeof newVal === 'object' && oldVal !== null && newVal !== null) {
        return JSON.stringify(oldVal) !== JSON.stringify(newVal)
      }
      return oldVal !== newVal
    })
  }

  getOperationVariant(operationType: string): string {
    const variants: { [key: string]: string } = {
      INSERT: 'success',
      UPDATE: 'info',
      DELETE: 'danger'
    }
    return variants[operationType] || 'secondary'
  }

  getOperationLabel(operationType: string): string {
    const labels: { [key: string]: string } = {
      INSERT: this.$t('account_detail.audit.operation_insert').toString(),
      UPDATE: this.$t('account_detail.audit.operation_update').toString(),
      DELETE: this.$t('account_detail.audit.operation_delete').toString()
    }
    return labels[operationType] || operationType
  }

  formatValue(value: unknown): string {
    if (value === null || value === undefined || value === '') return '—'
    if (typeof value === 'boolean') {
      return value ? this.$t('reuse.yes').toString() : this.$t('reuse.not').toString()
    }
    if (typeof value === 'object') return JSON.stringify(value)
    return String(value)
  }
}
